<template>
  <b-modal
    hide-footer
    size="md"
    centered
    id="long-term-block-modal"
    @hidden="hideModal"
  >
    <!-- Title -->
    <div class="text-center mb-2">
      <h3 class="font-weight-bold text-black">Long Term Block</h3>
    </div>

    <!-- Subtitle -->
    <p class="text-center font-weight-bold text-black">
      Long term block can temporarily disable the account for 6 or 12 months.
    </p>

    <!-- Description text -->
    <p class="text-center text-black">With a long term block, please note:</p>

    <!-- Bullet list -->
    <ul class="text-black">
      <li>You will not be able to log into your account</li>
      <li>All pending bets will remain</li>
      <li>If you would like to withdraw, you can contact customer support</li>
      <li>
        You still stop receiving marketing material within 24 hours for the
        duration of your break
      </li>
      <li>You will be able to log in after your break is completed</li>
      <li>The break will take effect immediately</li>
    </ul>

    <!-- Start Date -->
    <b-form-group label="Start Date" class="text-black">
      <flat-pickr v-model="form.startDate" :config="configDate" />
    </b-form-group>

    <!-- Break Period -->
    <b-form-group label="Select Break Period" class="text-black">
      <b-form-select v-model="form.breakPeriod">
        <option disabled value="">Select break period</option>
        <option value="6">6 months</option>
        <option value="12">12 months</option>
      </b-form-select>
    </b-form-group>

    <!-- Comments -->
    <b-form-group label="Comments" class="text-black">
      <b-form-input
        v-model="form.comments"
        placeholder="Comments"
      ></b-form-input>
    </b-form-group>

    <!-- Buttons -->
    <b-button
      block
      variant="danger"
      class="mt-2"
      :disabled="loadingClientProfile"
      @click="handleSubmit"
    >
      SET LONG TERM BLOCK
    </b-button>

    <b-button block class="mt-2" @click="hideModal"> CANCEL </b-button>
  </b-modal>
</template>

<script>
import {
  BModal,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BButton,
} from "bootstrap-vue";
import { mapState, mapActions } from "vuex";
import useToastHandler from "@/services/toastHandler";
import flatPickr from "vue-flatpickr-component";
import { addMonths } from "date-fns";
export default {
  components: {
    BModal,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BButton,
    flatPickr,
  },
  data() {
    return {
      form: {
        startDate: "",
        breakPeriod: "",
        comments: "",
      },
      configDate: {
        enableTime: true,
        altFormat: "Y-m-d H:i:ss",
        enableSeconds: true,
        altInput: true,
        static: true,
        minDate: new Date(),
      },
    };
  },
  watch: {},
  computed: {
    ...mapState("user/detail", ["loadingClientProfile"]),
  },
  methods: {
    ...mapActions({
      updateClientProfile: "user/detail/updateClientProfile",
      fetchUser: "user/detail/asyncUser",
    }),
    async handleSubmit() {
      const payload = {
        userId: this.$route.params.id,
        breakStartDate: new Date(this.form.startDate).toISOString(),
        breakTime: addMonths(
          new Date(this.form.startDate),
          parseInt(this.form.breakPeriod)
        ).toISOString(),
        reasonUpdate: this.form.comments,
      };
      const result = await this.updateClientProfile(payload);
      if (result) {
        this.showToastSuccess("Long Term Break successfully!");
        this.hideModal();
        this.fetchUser({ id: this.$router.currentRoute.params.id });
      }
    },
    hideModal() {
      this.form = {
        startDate: "",
        breakPeriod: "",
        comments: "",
      };
      this.$bvModal.hide("long-term-block-modal");
    },
  },
  setup() {
    const { showToastSuccess, showToastError } = useToastHandler();
    return {
      showToastSuccess,
      showToastError,
    };
  },
};
</script>
